import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Container, Grid, Divider, Segment, GridColumn, Modal, Input } from 'semantic-ui-react';
import { Button, Icon, Image, Label, Card, List } from 'semantic-ui-react';
import { Link, useParams, Redirect } from 'react-router-dom';
import { AppState } from '../../context';
import { Loader, Dimmer } from 'semantic-ui-react';
import Avatar from 'react-avatar';
import TopMenu from '../TopMenu'
import { dbFamMember, dbCaregivers, dbTasks } from '../../firebase';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import Senior from '../ProfileCreation/Senior';

const FamilyProfile = () => {
  const someContext = useContext(AppState);
  
  const [ModalOpensettings, setModalOpensettings] = useState(false);
  const {
    globallogged,
    setGlobalLogged,
    user,
    setUser,
    familyMembers,
    caregivers,
    tasks,
    name,
    setName,
    seniors
  } = someContext;
  const withMenu = (page) => {
    return (
      <Container>
        <TopMenu />
        {page}
      </Container>
    )
  };


  const params = useParams();
  const uidString = params["userid"];
  const idList = familyMembers ? familyMembers[uidString]["seniors"] : ""

  const SettingsModal = () => {
    return (
      <Modal open={ModalOpensettings} basic size='small' centered={true} >
        <div style={{ textAlign: "center" }}>
          <Modal.Actions >
            <Button.Group vertical style={{ width: "200px" }}>
              <div style={{ width: "40px", marginLeft: "205px", marginBottom: "5px" }}>
                <Button basic icon="close" color="white" inverted onClick={() => setModalOpensettings(false)} />
              </div>
              <Button basic color='green' as={Link} to={`/familymembers/manageview/${uidString}`}>Add Family Members</Button>
              <Button basic color='green' as={Link} to={`/familymembers/add/caregiver/${uidString}/1`}>Add Caregivers</Button>
              <Button inverted color='red' as={Link} to={'../../login'} onClick={() => setGlobalLogged(false) }>Logout</Button>
            </Button.Group>
          </Modal.Actions>
        </div>
      </Modal>
    );
  };

  const [loader, setLoader] = useState(true);
  setTimeout(() => { setLoader(false) }, 500)

  function Loaded() {
    function Care({ input }) {
      return (
        <List.Item style={{ marginLeft: "30px" }}>
          <List.Content>
            <List.Header>{caregivers && caregivers[input] ? caregivers[input]["firstName"] : ""}</List.Header>
            <div style={{ fontWeight: "normal", color: "grey", fontSize: "11px" }}>
              {caregivers[input] && caregivers[input]["tasks"] ? Object.values(caregivers[input]["tasks"]).length + " tasks assigned" : "0 tasks assigned"}
            </div>
          </List.Content>
        </List.Item>)
    }
    function SecFam({ input }) {
      return (
        <List.Item style={{ marginLeft: "30px" }}>
          <List.Content>
            <List.Header>{familyMembers && familyMembers[input] ? familyMembers[input]["firstName"] : ""}</List.Header>
            <div style={{ fontWeight: "normal", color: "grey", fontSize: "11px" }}>Emergency contact</div>
          </List.Content>
        </List.Item>)
    }
    function Seniorr({ input }) {
      return (
        <List.Item style={{ marginLeft: "30px" }}>
          <List.Content>
            <List.Header>{seniors[input] ? seniors[input]["firstName"] : ""}</List.Header>
            {/* {seniors[input] && seniors[input]["HealthIssues"] && Object.keys(seniors[input]["HealthIssues"]).length ? Object.keys(seniors[input]["HealthIssues"]).map(function (val) {
              return (<Label circular key={val} style={{ marginTop: "3px", marginRight: "5px" }} color={"black"} size={"mini"}>
                <div style={{ marginLeft: "5px", marginRight: "5px" }}>{val}</div>
              </Label>)
            }) : <Label color="black" size={"mini"}> {seniors[input] ? Object.keys(seniors[input]["HealthIssues"]) : ""}</Label>}<br /> */}
            {/* {seniors[input] && seniors[input]["Medications"] && Object.keys(seniors[input]["Medications"]).length ? Object.keys(seniors[input]["Medications"]).map(function (val) {
              return (<Label key={val} circular style={{ marginTop: "5px", marginRight: "5px" }} color={"grey"} size={"mini"}>
                <div style={{ marginLeft: "5px", marginRight: "5px", marginTop: "1px", marginBottom: "1px" }}>{val}</div>
              </Label>)
            }) : <Label color="grey" size={"mini"}> {seniors[input] ? Object.keys(seniors[input]["Medications"]) : ""}</Label>} */}
          </List.Content>
        </List.Item>)
    }
    if (globallogged)
    {
    return (
      familyMembers ? <div>
        <TopMenu />
        <Container>
          <SettingsModal />
          <Grid padded>
            <Grid.Row>
              <Grid.Column width={4}>
                <Avatar style={{ marginTop: "15px" }} name={familyMembers[uidString]["firstName"] + " " + familyMembers[uidString]["lastName"]} round={true} size="70" />
              </Grid.Column>
              <Grid.Column width={12} style={{ marginTop: "25px" }}>
                <Grid.Row>
                  <Header as="h2" style={{ fontWeight: "normal", fontSize: "26px" }}>
                    {familyMembers ? familyMembers[uidString]["firstName"] + " " + familyMembers[uidString]["lastName"] + " " : ""}
                    <Button onClick={() => setModalOpensettings(true)} style={{ marginLeft: "3px", padding: "7px" }} compact size="mini" circular><Icon fitted name="setting" /></Button>
                  </Header>
                </Grid.Row>

                <Grid.Row>
                  <Header as="h5" color="grey" sub style={{ marginLeft: "2px" }}>
                    <Header.Content>
                      {"Family Member"}
                    </Header.Content >
                  </Header>
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Header as="h4" style={{ fontWeight: "normal", fontSize: "18px", marginTop: "30px" }}>
                {familyMembers[uidString]['careBool'] ? "Registered Caregivers" : "No Registered Caregivers"}
              </Header>
            </Grid.Row>
          </Grid>

          <List>
            {familyMembers[uidString] ? familyMembers[uidString]['careBool'] ? familyMembers[uidString]["caregivers"].map((input) => <Care input={input} />) : "" : ""}
          </List>
          <Divider></Divider>
          <Grid.Row>
            <Header as="h4" style={{ fontWeight: "normal", fontSize: "18px" }}>
              {familyMembers[uidString]['seniorBool'] ? "Registered seniors" : "No Registered seniors"}
            </Header>
          </Grid.Row>
          <List>
            {familyMembers[uidString] && familyMembers[uidString]['seniorBool']? familyMembers[uidString]["seniors"].map((input) => <Seniorr input={input} />) : ""}
          </List>
          <Divider></Divider>
          <Grid.Row>
            <Header as="h4" style={{ fontWeight: "normal", fontSize: "18px" }}>
              {familyMembers[uidString] ? familyMembers[uidString]["lastName"] : ""}
              {" Family"}
            </Header>
          </Grid.Row>
          <List>
            {familyMembers[uidString] && familyMembers[uidString]["secondaryFam"] && familyMembers[uidString]["secondaryFam"] !== "hi" ? familyMembers[uidString]["secondaryFam"].map((input) => <SecFam input={input} />) : ""}
          </List>
        </Container>
      </div> :
        <Dimmer active>
          <Loader size='huge'>Loading</Loader>
        </Dimmer>
    )}
    else{
      return <Redirect to={'/login'} push={true} />
    }
  }
  return (<div>
    {loader ?
      <Dimmer active>
        <Loader size='huge'>Loading</Loader>
      </Dimmer> : <Loaded />}
  </div>);
}

export default FamilyProfile;